import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { variantPaths } from "api/apiPaths";
import client from "api/client";
import { VariantCreateActionRequestModel } from "./actions/create/VariantCreateActionRequestModel";
import { VariantUpdateActionRequestModel } from "./actions/update/VariantUpdateActionRequestModel";
import { VariantDetailResponseModel } from "./detail/VariantDetailResponseModel";
import { VariantsRequestModel } from "./model/VariantsRequestModel";
import { VariantsResponseModel } from "./model/VariantsResponseModel";

export interface IVariantsRepository {
  getList(
    params: VariantsRequestModel
  ): Promise<BaseApiResponseModel<VariantsResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<VariantDetailResponseModel>>;
  createVariant(
    body: VariantCreateActionRequestModel
  ): Promise<BaseApiResponseModel<VariantDetailResponseModel>>;
  updateVariant(
    body: VariantUpdateActionRequestModel
  ): Promise<BaseApiResponseModel<VariantDetailResponseModel>>;
  deleteVariant(params: {
    code: string;
  }): Promise<BaseApiResponseModel<VariantDetailResponseModel>>;
}

class VariantsImpl implements IVariantsRepository {
  async getList(
    params: VariantsRequestModel
  ): Promise<BaseApiResponseModel<VariantsResponseModel[]>> {
    return await client?.get(variantPaths?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<VariantDetailResponseModel>> {
    return await client?.get(variantPaths?.DETAIL, params);
  }

  async createVariant(
    body: VariantCreateActionRequestModel
  ): Promise<BaseApiResponseModel<VariantDetailResponseModel>> {
    return await client?.post(variantPaths?.CREATE, body);
  }

  async updateVariant(
    body: VariantUpdateActionRequestModel
  ): Promise<BaseApiResponseModel<VariantDetailResponseModel>> {
    return await client?.put(variantPaths?.UPDATE, body);
  }

  async deleteVariant(params: {
    code: string;
  }): Promise<BaseApiResponseModel<VariantDetailResponseModel>> {
    return await client?.delete(variantPaths?.DELETE, params);
  }
}

export const defaultVariantsRepository = new VariantsImpl();
